import cn from 'classnames';
import { useCallback, useContext } from 'react';

import { AuthFormContext } from '../context';

import css from './misc.css';

export const AuthTitle: FC<{
    className?: string;
    children?: ReactNode;
}> = ({ children, className }) => <h1 className={cn(css.title, className)}>{children}</h1>;

export const AuthHelp: FC<{
    className?: string;
    children?: ReactNode;
}> = ({ children, className }) => <div className={cn(css.help, className)}>{children}</div>;

export const AuthConfirm: FC<{
    className?: string;
    children?: ReactNode;
}> = ({ children, className }) => <div className={cn(css.confirm, className)}>{children}</div>;

export const AuthButton: FC<{
    disabled?: boolean;
    type?: 'submit' | 'button' | 'reset';
    className?: string;
    notice?: string;
    onClick?: (form) => void;
    children?: ReactNode;
}> = ({ children, className, disabled, notice, onClick, type }) => {
    const form = useContext(AuthFormContext);
    const click = useCallback(
        (e) => {
            if (onClick) {
                onClick(form);
                if (type === 'submit') {
                    e.preventDefault();
                }
            }
        },
        [form, onClick, type],
    );

    return (
        <div className={css.btnWrap}>
            <button className={cn(css.button, disabled && css.disabled, className)} type={type} onClick={click}>
                {children}
            </button>
            {notice && <em className={css.notice}>{notice}</em>}
        </div>
    );
};
